import React from "react";
import { Link } from "react-router-dom";
export default function About() {
  return (
    <div data-testid="about-page" className="bg-[#F5EFE4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-40 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <p className="overline">The House</p>
            <h1 className="font-serif text-5xl lg:text-7xl mt-4 leading-[1.02] text-[#1A1815]">A house of quiet craftsmen.</h1>
          </div>
          <p className="lg:col-span-5 text-[#6B665E] leading-relaxed">Luxor was founded in 2026 by a small collective of hoteliers, chauffeurs, and estate managers with a shared frustration: excellence is easy to imagine and hard to organise.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16 items-start">
          <div><img src="https://images.unsplash.com/photo-1522255272218-7ac5249be344?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="Luxor" className="w-full h-[560px] object-cover" /></div>
          <div className="space-y-10">
            {[["Principle 01","One point of contact.","Every client has a dedicated concierge who knows every service they use."],["Principle 02","Vetted, insured, quiet.","We hire slowly. We fire fairly. We work invisibly."],["Principle 03","No surprises but pleasant ones.","Fixed rates, transparent scope, elegant delivery. Always."]].map(([tag, title, body]) => (
              <div key={tag}><p className="overline">{tag}</p><h3 className="font-serif text-3xl mt-2 text-[#1A1815]">{title}</h3><p className="text-[#6B665E] mt-3 leading-relaxed">{body}</p></div>
            ))}
            <Link to="/book" className="luxor-btn-primary inline-flex mt-2">Reserve a service</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
